import type { FC, ReactNode } from 'react'

import { Reveal } from '@/components/generals/reveal'
import { studioMeta } from '@/constants/site'
import { articles } from '@/constants/journal'

const META_SIZE = 'clamp(19px, 1.6vw, 23px)'

/* The thin index row the reference parks directly under the nav: what the page
   holds on the left, how long the studio has been running on the right. */
export const JournalHeader: FC = (): ReactNode => {
    return (
        <section
            id='journal-header'
            aria-label='Journal index'
            className='mx-auto w-full max-w-[1920px] px-5 pt-[calc(var(--nav-h)_+_26px)] lg:px-[33px] lg:pt-[calc(var(--nav-h)_+_40px)]'
        >
            <Reveal
                from='down'
                distance={18}
                duration={0.95}
                delay={0.1}
                className='flex items-start justify-between gap-6'
            >
                <p className='t-cond text-ink' style={{ fontSize: META_SIZE }}>
                    articles

                    <sup className='t-mono ml-[1px] text-brand'>
                        ({articles.length})
                    </sup>
                </p>

                <p className='t-cond text-ink' style={{ fontSize: META_SIZE }}>
                    ({studioMeta.years})
                </p>
            </Reveal>
        </section>
    )
}
